import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/order-form/insurance_full.svg'
import _imports_1 from '@/assets/images/order-form/insurance_light.svg'


const _withScopeId = n => (_pushScopeId("data-v-63d72169"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "あんしん補償パック", -1))
const _hoisted_2 = { class: "block insurance" }
const _hoisted_3 = { class: "insurance-plans" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "insurance-full",
  class: "full"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createTextVNode(" あんしん補償フル ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "body" }, [
    /*#__PURE__*/_createTextVNode(" 紛失・盗難や破損時に弁償代金を100％免除するサービスです。 "),
    /*#__PURE__*/_createElementVNode("span", null, "330円/日(税込)")
  ])
], -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "insurance-light",
  class: "light"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
    /*#__PURE__*/_createTextVNode(" あんしん補償ライト ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "body" }, [
    /*#__PURE__*/_createTextVNode(" 紛失・盗難や破損時に弁償代金を80％免除するサービスです。 "),
    /*#__PURE__*/_createElementVNode("span", null, "220円/日(税込)")
  ])
], -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "insurance-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "加入しない"),
  /*#__PURE__*/_createElementVNode("span", { class: "body" }, " 紛失・盗難や破損時に弁償代金が最大35,000円生じます。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "insurance",
          id: "insurance-full",
          checked: "checked",
          value: _ctx.insuranceOptions.full,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedInsurance) = $event))
        }, null, 8, _hoisted_4), [
          [_vModelRadio, _ctx.selectedInsurance]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "insurance",
          id: "insurance-light",
          value: _ctx.insuranceOptions.light,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedInsurance) = $event))
        }, null, 8, _hoisted_6), [
          [_vModelRadio, _ctx.selectedInsurance]
        ]),
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "insurance",
          id: "insurance-none",
          value: _ctx.insuranceOptions.none,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedInsurance) = $event))
        }, null, 8, _hoisted_8), [
          [_vModelRadio, _ctx.selectedInsurance]
        ]),
        _hoisted_9
      ])
    ])
  ], 64))
}